import React from "react"
import {FormattedMessage} from "react-intl"
import {InvoiceDto} from "../../../state/invoice/models"
import Proposal from "../../../state/proposal/Proposal"
import Integrations from "../../../integration/Integrations"
import {EventObjectDto} from "../../../state/event/Event"
import { BILLING_TYPE } from"../../../state/invoice/InvoiceBillingType"

const IntegrationKey = "square"
type OwnProps = {
    object: EventObjectDto
    invoice: InvoiceDto
    proposal: Proposal
}

const InvoiceExportedToSquareEvent = (props: OwnProps) => {
    const type = props.object.attributes.entityType
    const Url = Integrations.getExternalOrderUrl(props.object)

    const renderMessage = () => {
        switch (type) {
        case "main":
            return !isReturn() ?
                <FormattedMessage
                    id="invoice.analytics.events.exported.square.text"
                    defaultMessage="Invoice {identifier} has been exported to Square as an order"
                    values={{
                        identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    }}
                /> :
                <FormattedMessage
                    id="invoice.analytics.events.return_exported.square.text"
                    defaultMessage="Return {identifier} has been exported to Square"
                    values={{
                        identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                    }}
                />
        case "void":
            return <FormattedMessage
                id="invoice.analytics.events.exported.square.void_text"
                defaultMessage="Invoice {identifier} has been refunded in Square"
                values={{
                    identifier: <strong>{props.invoice.attributes.identifier}</strong>,
                }}
            />
        case "invoice-adjustment":
            return <></>
        case "payment-adjustment":
            return <></>
        case "inventory-adjustment":
            return <></>
        default:
            return <></>
        }
    }

    const isReturn = () => {
        return props.invoice && props.invoice.attributes.billingType === BILLING_TYPE.RETURN
    }

    return (
        <div className={"row"}>
            <div className={"col-12"}>
                <p className={"mb-2"}>
                    {renderMessage()}
                </p>
            </div>

            <div className={"col-12 d-flex align-items-center flex-wrap"}>
                <div className={"mr-3"}>
                    <a href={Url} target="_blank" rel="noreferrer">
                        {Integrations.getIntegrationLogoImage(IntegrationKey, 100, 25)}
                    </a>
                </div>
                {Url &&
                <div className={""}>
                    <p className={"mb-0"}>
                        <a href={Url} target={"_blank"} className={"btn btn-sm btn-outline-primary"} rel="noreferrer">
                            <FormattedMessage
                                id="invoice.analytics.events.exported.square.open"
                                defaultMessage="Open order in Square"
                            />
                        </a>
                    </p>
                </div>
                }
            </div>
        </div>
    )
}


export default InvoiceExportedToSquareEvent



// WEBPACK FOOTER //
// ./src/quote/analytics/events/invoice-exported-square.component.tsx